module.exports = __webpack_public_path__ + "assets/6b4fafe07d280858cf4ee278a2581d48.png";